import * as XLSX from "xlsx";

export const exportCSV = (worksheetData) => {
  // Create a worksheet from the data
  const worksheet = XLSX.utils.json_to_sheet(worksheetData);

  // Convert the worksheet to CSV format
  const csvData = XLSX.utils.sheet_to_csv(worksheet);

  // Create a Blob for the CSV data
  const data = new Blob([csvData], { type: "text/csv;charset=utf-8;" });

  // Create a download link
  const url = window.URL.createObjectURL(data);
  const link = document.createElement("a");
  link.href = url;
  link.download = "kit_data.csv"; // Set the file name
  link.click();

  // Revoke the URL to release memory
  window.URL.revokeObjectURL(url);
};
